import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import * as api from 'dashboard/resources/jackpots-next-draws.api';
import template from './jackpots-next-draws-widget.html';

const mapStateToThis = ({ config }) => {
  const { widgetsDataJackpotsAndDraws } = config;

  return {
    widgetsDataJackpotsAndDraws,
  };
};
const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux')
class JackpotsNextDrawsWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.loadDataAsync(() => api.fetchJackpotsAndDraws(this.widgetsDataJackpotsAndDraws));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class JackpotsNextDrawsWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isDisabledShare: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
    this.template = template;
    this.controller = JackpotsNextDrawsWidgetController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/jackpots-next-draws/jackpots-next-draws-widget-component.js